import React, { Component } from 'react';
import im1 from './img/Vector 7.svg'
import Fade from './Fade.js';
import './reg.css';
import './uikit.css';
import {WhiteBubbleIcon} from './WhiteBubbleIcon';



export class RegWrapper extends Component {

    constructor(props) {
        super(props)
        this.props = props 
    }

    render() {
        return (
            
            <div className='regWrapper'> 
      <div className="main-reg uk-flex uk-flex-left">
      {/*<img className="ring-top" src={im2} /> */}
      <div className="main-left uk-flex uk-flex-left uk-flex-column">
          
          <div className="logo"> <WhiteBubbleIcon />
          <span style={{ 'verticalAlign': 'middle'}}>ClickAnti</span> </div>
           
          <div className="owt-and-img">
              <img src={im1} />
              <div className="open-world-text">
                    <p> 
                        Хватит терять деньги из-за скликивания!
                    </p>
              </div>
          </div>
      </div>
      
      <div className="main-right uk-flex uk-flex-column">
            
            
            
            <Fade show={this.props.showErrorMsg}>
              <div className='errorMessage'>
                Ошибка: {this.props.errorMsg}
              </div>
            </Fade>

        {this.props.children}
        </div>
        </div>
        
        </div>
            
        )
    }

}


